var _react_refresh_temp_1;
_react_refresh_temp_1 = $RefreshSig$();
import { useCallback } from 'react';
import { translate, useToastService, writeToClipboard, } from '@lucidlink/uicore';
export const useCopyToClipboardWithToast = () => {
    _react_refresh_temp_1();
    const { addToast } = useToastService();
    /** When using this function, pass any options. The functions includes default toast showing up if copying to clipboard fails due to DOMException -> NotAllowedError.
     *
     * Make sure to try-catch and await if you think any part of your onSuccess or onError functions can throw an error.
     *
     * Otherwise you can just 'void' call the function.
     */
    const copyToClipboard = useCallback((data, { onError, onSuccess, shouldShowDefaultErrorToast = true, }) => {
        return writeToClipboard(data, {
            onError: (error) => {
                if (onError) {
                    onError(error);
                }
                if (shouldShowDefaultErrorToast) {
                    addToast({
                        'data-testid': 'copy-clipboard-default-error',
                        kind: 'negative',
                        content: {
                            message: translate('Copy to clipboard failed. Please try again. If the issue persists, try with a different browser.'),
                        },
                    });
                }
            },
            onSuccess: () => {
                if (onSuccess) {
                    onSuccess();
                }
            },
        });
    }, [addToast]);
    return { copyToClipboard };
};
_react_refresh_temp_1(useCopyToClipboardWithToast, "VgAgHtbP/pDmEBU1oKBTgdW1jNc=", false, () => [useToastService]);
